// Das native Drag-Bild ist leer/unsichtbar, wenn ein Vorfahre eine CSS-transform hat
// (z. B. die framer-motion Sidebar). Lösung: das gezogene Element klonen, kurz unsichtbar an
// document.body hängen (ohne transformierten Vorfahren) und als Drag-Bild setzen.
export function setzeDragBild(e) {
  const el = e.currentTarget;
  const rect = el.getBoundingClientRect();

  const klon = el.cloneNode(true);
  Object.assign(klon.style, {
    position: 'fixed',
    top: '-9999px',
    left: '0',
    margin: '0',
    width: `${rect.width}px`,
    pointerEvents: 'none',
    // fester Look wie das Sidebar-Item (Teal-Kasten, Amber-Text), bei 60 % Deckkraft
    opacity: '0.6',
    background: 'var(--cv-teal, #004D40)',
    color: 'var(--cv-amber, #FFBC00)',
    borderRadius: '12px',
    padding: '8px 12px',
    boxSizing: 'border-box',
  });
  // Text der Kopie auf Amber zwingen, unabhängig vom CSS-Variablen-Scope
  klon.querySelectorAll('*').forEach((n) => { n.style.color = 'var(--cv-amber, #FFBC00)'; });
  document.body.appendChild(klon);
  e.dataTransfer.setDragImage(klon, e.clientX - rect.left, e.clientY - rect.top);
  // Snapshot wird synchron beim dragstart gezogen → Klon im nächsten Tick wieder entfernen.
  setTimeout(() => klon.remove(), 0);
}
